<div class="row">
    <div class="col" [formGroup]="form">

        <!--
        TODO: This should have virtul scroll implemented when this issue is fixed: https://github.com/angular/components/issues/10122
                There is a work around: https://stackblitz.com/edit/angular-table-virtual-scroll-sticky-headers-xsvmgt?file=src%2Fapp%2Fapp.component.ts
                In this particular case sticky headers and footers were prioritized over virtual scrolling
        -->

        <div class="table__viewport" formArrayName="korebog">
            <table
                class="table table-hover table-striped table-sm table-frame__body"
                cdk-table
                [dataSource]="formKorebog"
                [trackBy]="trackById">

                <ng-container cdkColumnDef="dato">
                    <th cdk-header-cell *cdkHeaderCellDef>Dato</th>
                    <td cdk-cell *cdkCellDef="let kb let i = index" [formGroupName]="i" class="td__date">
                        <span *ngIf="!isEdit(kb.value.id)">
                            {{ kb.get('dato').value | date:'dd-MM-yyyy' }}
                        </span>
                        <app-date-picker-dk
                            *ngIf="isEdit(kb.value.id)"
                            [formControl]="kb.controls['dato']"
                        ></app-date-picker-dk>
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="kunde">
                  <th cdk-header-cell *cdkHeaderCellDef>Kunde</th>
                  <td cdk-cell *cdkCellDef="let kb let i = index" [formGroupName]="i">
                    <span *ngIf="!isEdit(kb.value.id)">
                        {{ kb.get('label')?.value }}
                    </span>
                    <ng-select
                        class="ng-select-sm ng-select__clientcase"
                        *ngIf="isEdit(kb.value.id)"
                        (change)="onClientChange(kb)"
                        [items]="ugerapportKunder"
                        placeholder="Vælg kunde (valgfri)"
                        bindValue="kid"
                        formControlName="kid">
                    </ng-select>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="sag">
                  <th cdk-header-cell *cdkHeaderCellDef>Sag</th>
                  <td cdk-cell *cdkCellDef="let kb let i = index" [formGroupName]="i">
                    <span *ngIf="!isEdit(kb.value.id)">
                        {{ kb.get('sagBeskrivelse')?.value }}
                    </span>
                    <ng-select
                        *ngIf="isEdit(kb.value.id)"
                        class="ng-select-sm ng-select__clientcase"
                        placeholder="Vælg sag (valgfri)"
                        bindValue="sag"
                        bindLabel="beskrivelse"
                        formControlName="sag">
                        <ng-option
                            *ngFor="let kbs of ugerapportSager | ugerapportSagerFilter:kb.get('kid').value"
                            [value]="kbs.sag">
                            {{ kbs.beskrivelse }}
                        </ng-option>
                    </ng-select>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="destination">
                    <th cdk-header-cell *cdkHeaderCellDef>Destination</th>
                    <td cdk-cell *cdkCellDef="let kb let i = index" [formGroupName]="i">
                        <span *ngIf="!isEdit(kb.value.id)">{{ kb.get('destination').value }}</span>
                        <input *ngIf="isEdit(kb.value.id)" type="text" class="form-control form-control-sm" formControlName="destination">
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="beskrivelse">
                    <th cdk-header-cell *cdkHeaderCellDef>Beskrivelse</th>
                    <td cdk-cell *cdkCellDef="let kb let i = index" [formGroupName]="i">
                        <span *ngIf="!isEdit(kb.value.id)">{{ kb.get('beskrivelse').value }}</span>
                        <input *ngIf="isEdit(kb.value.id)" type="text" class="form-control form-control-sm" formControlName="beskrivelse">
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="km">
                    <th cdk-header-cell *cdkHeaderCellDef class="text-end">KM</th>
                    <td class="text-end td__time-money" cdk-cell *cdkCellDef="let kb let i = index" [formGroupName]="i">
                        <span *ngIf="!isEdit(kb.value.id)">{{ kb.get('km').value }}</span>
                        <input *ngIf="isEdit(kb.value.id)" type="text" class="form-control form-control-sm text-end" formControlName="km">
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="slet">
                    <th cdk-header-cell *cdkHeaderCellDef class="text-center">
                        <i class="fa fa-pencil d-inline pe-2"></i>
                        <i class="fa fa-floppy-o d-inline pe-2"></i>
                        <i class="fa fa-ban d-inline pe-2"></i>
                        <i class="fa fa-trash d-inline pe-2"></i>
                    </th>
                    <td cdk-cell *cdkCellDef="let kb" class="text-center">
                        <span *ngIf="!isEdit(kb.value.id) && kb.value.afregnet === null" class="clickable--link pe-2" ngbTooltip="Rediger" (click)="onEdit(kb.value)">
                            <i class="case__icon fa fa-pencil"></i>
                        </span>
                        <span *ngIf="!isEdit(kb.value.id) && kb.value.afregnet === null" class="clickable--link pe-2" ngbTooltip="Slet" (click)="onDelete($event, kb.value)">
                            <i class="case__icon fa fa-trash text-danger"></i>
                        </span>
                        <span *ngIf="isEdit(kb.value.id)" class="clickable--link pe-2" ngbTooltip="Gem" (click)="onSave($event, kb)">
                            <i class="case__icon case__icon--show fa fa-floppy-o"></i>
                        </span>
                        <span *ngIf="isEdit(kb.value.id)" class="clickable--link pe-2" ngbTooltip="Annuller" (click)="onCancel($event, kb)">
                            <i class="case__icon case__icon--show fa fa-ban text-danger"></i>
                        </span>
                    </td>
                </ng-container>

                <!-- Footer -->

                <ng-container cdkColumnDef="blank">
                    <th cdk-footer-cell *cdkFooterCellDef></th>
                </ng-container>

                <ng-container cdkColumnDef="total-text">
                    <th cdk-footer-cell *cdkFooterCellDef>I alt uafregnet</th>
                </ng-container>

                <ng-container cdkColumnDef="total-text-afregnet">
                    <th cdk-footer-cell *cdkFooterCellDef>I alt afregnet</th>
                </ng-container>

                <ng-container cdkColumnDef="total-km">
                    <th cdk-footer-cell *cdkFooterCellDef class="text-end">{{ totalKm }}</th>
                </ng-container>

                <ng-container cdkColumnDef="total-km-afregnet">
                    <th cdk-footer-cell *cdkFooterCellDef class="text-end">{{ totalKmAfregnet }}</th>
                </ng-container>

                <tr class="table__header--border" cdk-header-row *cdkHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr
                    cdk-row *cdkRowDef="let row; columns: displayColumns"
                    [class.text-success]="row.value.afregnet !== null"
                ></tr>
                <tr class="table__footer--border text-success" cdk-footer-row *cdkFooterRowDef="['total-text-afregnet', 'blank', 'blank', 'blank', 'blank', 'total-km-afregnet', 'blank']; sticky: true"></tr>
                <tr cdk-footer-row *cdkFooterRowDef="['total-text', 'blank', 'blank', 'blank', 'blank', 'total-km', 'blank']; sticky: true"></tr>

            </table>

        </div>

    </div>
</div>
